import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { formatNumber } from '../../../../../helpers/numbers'

import Field from '../../../../../components/Form/Field'
import FieldLabelWrapper from '../../../../../features/components/Form/FieldLabelWrapper'

import { IMPRESSIONS } from '../../../../Google/UploadGoogleAdCreative/UploadGoogleAdCreativeForm/CampaignForm/fields'
import { objectiveLabelsForOptimizedImpressions } from '../../../CombinedCampaignBudgetEdit/Sections/FacebookEditSections/fields'
import {
  PACING_TYPE,
  pacingTypeOptions
} from '../../../../DV360/UploadDV360AdCreative/UploadDV360AdCreativeForm/CampaignForm/fields'

const RemainingCampaignImpressionsBudgetFields = ({
  formik,
  remainingImpressions,
  calculatedImpressions,
  objective = '',
  showPacing = false,
  impressionsFieldPlaceholder = 'Lifetime Impressions',
  isDailyBudget = false
}) => {
  const { t } = useTranslation()

  const { values } = formik

  const objectiveLabel = useMemo(
    () =>
      objectiveLabelsForOptimizedImpressions[objective] ||
      // handle case when objective label is not in the dictionary
      objective.toLowerCase().replace('_', ' '),
    [objective]
  )

  return (
    <>
      {!isDailyBudget && (
        // This description is not applicable for daily budgets, so we only show it for lifetime budgets
        <p>{t('An approximate number of impressions for the entire run-time of the campaign.')}</p>
      )}
      <p>{t(`Your remaining total is ${formatNumber(remainingImpressions)} impressions`)}</p>
      {!!calculatedImpressions && (
        <p>
          {t(
            `This campaign has delivered ${formatNumber(values[IMPRESSIONS])} ${objectiveLabel} optimised impressions, which is equivalent to ${formatNumber(calculatedImpressions)} impressions. You cannot set the budget lower than this amount.`
          )}
        </p>
      )}
      <Field
        type="number"
        formik={formik}
        name={IMPRESSIONS}
        placeholder={t(impressionsFieldPlaceholder)}
        autoComplete="off"
        inputMode="numeric"
      />
      {showPacing && (
        <FieldLabelWrapper label={t('Pacing')} labelFor={PACING_TYPE}>
          <Field placeholder="Pacing" formik={formik} name={PACING_TYPE} options={pacingTypeOptions} />
        </FieldLabelWrapper>
      )}
    </>
  )
}

RemainingCampaignImpressionsBudgetFields.propTypes = {
  formik: PropTypes.object.isRequired,
  remainingImpressions: PropTypes.number.isRequired,
  calculatedImpressions: PropTypes.number,
  objective: PropTypes.string,
  impressionsFieldPlaceholder: PropTypes.string,
  showPacing: PropTypes.bool,
  isDailyBudget: PropTypes.bool
}

export default RemainingCampaignImpressionsBudgetFields
